if (typeof window.dogBreedSelectorInitialized === 'undefined') {
  window.dogBreedSelectorInitialized = true;

  function searchresultbreed(input) {
    let get_value = input.value.toLowerCase();
    let dropdown = input
      .closest(".suggestion-container")
      .querySelector(".dropdown-content");

    let breedLinks = dropdown.querySelectorAll(".option-list");

    breedLinks.forEach(function (breed) {
      let breed_html = breed.innerHTML.toLowerCase();
      breed.style.display = breed_html.includes(get_value) ? "block" : "none";
    });
  }

  let toggleDropdownBtn = document.querySelectorAll(
    ".suggestion-container .toggle-dropdown-btn"
  );

  let dropdownContent = document.querySelectorAll(
    ".suggestion-container .dropdown-content .option-list"
  );

  if (toggleDropdownBtn.length) {
    toggleDropdownBtn.forEach(function (btn) {
      btn.addEventListener("click", function () {
        let container = this.closest(".suggestion-container");
        let content_element = container.querySelector(".dropdown-content");

        content_element.classList.toggle("hide");

        if (!content_element.classList.contains("hide")) {
          let input = container.querySelector(".search-results-input");

          if (input) {
            input.focus();
          }
        }
      });
    });
  }

  if (dropdownContent.length) {
    dropdownContent.forEach(function (breed) {
      breed.addEventListener("click", function () {
        let container = this.closest(".suggestion-container");

        let selected_breed = this.innerHTML;
        let selected_size = this.getAttribute("data-value");

        let content_element = container.querySelector(".dropdown-content");

        content_element.classList.add("hide");

        let changeableText = container.querySelector(
          ".btn-changeable-text"
        );

        if (changeableText) {
          changeableText.innerHTML = selected_breed;
        }

        let recommendationSection = container.querySelector(
          ".recommendation-section"
        );

        if (recommendationSection) {
          recommendationSection.classList.remove("hide");

          let titlePhrase = recommendationSection.querySelector(
            ".selected-value-title-phrase"
          );

          let selectedValue = recommendationSection.querySelector(
            ".selected-value"
          );

          if (titlePhrase) {
            titlePhrase.innerHTML =
              "For your " + selected_breed + ", we recommend:";
          }

          if (selectedValue) {
            selectedValue.innerHTML = selected_size;
          }
        }

        /*
         * Find variant selector
         */
        let variantsSelector = container.parentElement?.querySelector(
          ".mff_variant-selects"
        );

        if (variantsSelector == null) {
          let sizeGuidePopup = container.closest(".size-guide-popup");

          if (sizeGuidePopup && sizeGuidePopup.getAttribute("id")) {
            let variantsSelectorID = sizeGuidePopup
              .getAttribute("id")
              .replace("sizeGuidePopup-", "");

            variantsSelector = document.querySelector(
              `product-info[data-section="${variantsSelectorID}"]`
            );
          }
        }

        if (variantsSelector == null) {
          variantsSelector =
            container.parentElement?.parentElement?.querySelector(
              ".mff_variant-selects"
            );
        }

        if (!variantsSelector) {
          console.log(
            "No variant selector found for the selected breed"
          );
          return;
        }

        /*
         * Handle dropdown size selector
         */
        let selectElement = variantsSelector.querySelector(
          '.mff_select__select[data-id="Size"]'
        );

        if (selectElement) {
          let matchingOption = Array.from(
            selectElement.options || []
          ).find(function (option) {
            let optionSize = option.value
              ?.split(/\s*[-–_]\s*/)[0]
              ?.trim();

            return (
              optionSize?.toLowerCase() ===
              selected_size?.trim().toLowerCase()
            );
          });

          if (matchingOption) {
            selectElement.value = matchingOption.value;

            selectElement.dispatchEvent(
              new Event("change", {
                bubbles: true,
                cancelable: true
              })
            );

            return;
          }

          showNoMatchingResult();
          return;
        }

        /*
         * Handle radio / swatch size selector
         */
        let radioInputs = variantsSelector.querySelectorAll(
          'input[type="radio"][data-id="Size"]'
        );

        if (radioInputs.length) {
          let matchingRadio = Array.from(radioInputs).find(
            function (input) {
              let optionSize = input.value
                ?.split(/\s*[-–_]\s*/)[0]
                ?.trim();

              return (
                optionSize?.toLowerCase() ===
                selected_size?.trim().toLowerCase()
              );
            }
          );

          if (matchingRadio) {
            /*
             * Use click() instead of manually setting checked.
             * This allows the Shopify/theme swatch logic to run.
             */
            matchingRadio.click();
            return;
          }

          showNoMatchingResult();
          return;
        }

        console.log(
          "No matching Size select or swatch found for the selected breed"
        );

        /*
         * Show no matching result
         */
        function showNoMatchingResult() {
          if (!recommendationSection) {
            return;
          }

          recommendationSection.classList.remove("hide");

          let titlePhrase = recommendationSection.querySelector(
            ".selected-value-title-phrase"
          );

          let selectedValue = recommendationSection.querySelector(
            ".selected-value"
          );

          if (titlePhrase) {
            titlePhrase.innerHTML =
              `For your ${selected_breed}, no matching result found!`;
          }

          if (selectedValue) {
            selectedValue.innerHTML = "";
          }
        }
      });
    });
  }

  /*
   * Close dropdown when clicking outside
   */
  document.addEventListener("click", function (event) {
    document
      .querySelectorAll(
        ".suggestion-container .dropdown-content"
      )
      .forEach(function (dropdown) {
        let container = dropdown.closest(
          ".suggestion-container"
        );

        if (container && !container.contains(event.target)) {
          dropdown.classList.add("hide");
        }
      });
  });
}